// extracted by mini-css-extract-plugin
export default {"icons":"Home_icons__zTu6z","visible":"Home_visible__tFs0N","whatsapp":"Home_whatsapp__0gcsE","scrollToTop":"Home_scrollToTop__I7GaK"};